"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => ({
    artifactSlug: (0, cloneUtils_1.getClonedArtifactSlug)(artifactToClone.artifactSlug, cloneMap),
    artifactDocumentId: newArtifactDocumentId,
    creditFacilitySlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.creditFacilitySlug, cloneMap),
    loanProductSlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.loanProductSlug, cloneMap),
    externalFilename: null,
    id: (0, uuid_1.v4)(),
    type: node_1.artifactType,
    // Schema-driven remap covers the top-level ref, the nested
    // lenderVerificationConfig string refs, and the
    // borrowerEligibilityResultsArtifactSlugs slug→slug record (keys + values).
    configuration: (0, cloneUtils_1.remapConfigSlugRefs)(node_1.NodeConfigSchema, artifactToClone.configuration, cloneMap),
});
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map